import { styled } from '@linaria/react'

export const ElInputError = styled.p`
  color: var(--intent-danger);
  font-size: var(--font-size-small);
  margin: 0.25rem;
  text-align: left;
`
